import {
  Box,
  Chip,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useMemo, useEffect } from "react";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { FilterMatchMode } from "primereact/api";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import AddIcon from "@mui/icons-material/Add";
import { getRegionColumns } from "../../const/AssertData";
import { RegionMaster } from "../../types/assetTypes";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import { getProjectMasterDataList, getRegionById, getRegionMasterDataList, saveRegion } from "../../api/Services/masterServie";
import { PAGESEND, PAGESTART } from "../../api/endpoint";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { RootState } from "../../store/Reduxstore";

interface AssetRegionProps {
  setPathname: (path: string) => void;
}

const Region: React.FC = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<RegionMaster[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [projectOptions, setprojectOptions] = useState<{ id: number; name: string }[]>([]);
  const [assetRegionData, setAssetRegionData] = useState<RegionMaster>(
    {
      regionId: 0,
      regionName: "",
      regions: [],
      projectIds: []
    }
  );

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getProjectMasterDataList(PAGESTART, PAGESEND, {}); // Provide default values
        if (response.status.code === 200) {
          setprojectOptions(response.data.map(projectIds => ({
            id: projectIds.projectId,
            name: projectIds.projectName ?? "", // default to empty string if null
          })));


        } else {
          setprojectOptions([]);
          CustomMessage(response.status.message, "error", enqueueSnackbar);
        }
      } catch (error: any) {
        CustomMessage(error.message, "error", enqueueSnackbar);
      }
    };

    fetchUser();
  }, []);



  // Memoized column definition
  const columns = useMemo(() => getRegionColumns(), []);

  if (columns.filter((val) => val.field === "action").length === 0) {
    columns.push({
      field: "action",
      header: "Action",
      sortable: false,
      filter: false,
      filterField: "action",
      filterPlaceholder: "Search",
      style: { minWidth: "12rem" },
      body: (rowData: any) => (
        <ReusablePrimeButton
          icon="pi pi-pencil"
          className="p-button-rounded p-button-outlined"
          onClick={() => handleEditFamilyAsset(rowData.regionId)}
        />
      ),
    });
  }

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );

  const handleEditFamilyAsset = async (regionId: number) => {
    dispatch(setLoading(true));
    try {
      const response = await getRegionById(regionId);
      let { data, status } = response;
      if (status.code === 200 && data) {
        setAssetRegionData({
          regionId: data.regionId,
          regionName: data.regionName,
          regions: [],
          projectIds: data.projectIds, // <-- map from backend format if needed
        });

        setOpenDialog(true);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  // Generate filters dynamically

  const onFetchData = async (page: number, rows: number, filter?: Record<string, any>) => {
    dispatch(setLoading(true));
    try {
      const { data, status, pagination } =
        await getRegionMasterDataList(page, rows, filter ?? filterData);
      if (status.code === 200 && data?.length > 0) {
        setData(data);
        setPagination({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setData([]);
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setAssetRegionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setOpenDialog(false);
    setAssetRegionData({
      regionId: 0,
      regionName: "",
      regions: [],
      projectIds: []
    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event?.preventDefault();
    if (assetRegionData.regionName === "") {
      CustomMessage("Add the name", "error", enqueueSnackbar);
      return;
    }
    dispatch(setLoading(true));
    try {
      const response = await saveRegion(assetRegionData);
      let { status } = response;
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, "success", enqueueSnackbar);
        handleClear();
        onFetchData(PAGESTART, PAGESEND, filterData);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const userDetails = useSelector((state: RootState) => state.auth)
  return (
    <>
      <div
        // className="mb-0 add-absolute"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          //   top: "-37px",
          //   zIndex: "1",
        }}
      >
        {userDetails.role.some(
          r => r.roleName === "Admin" || r.roleName === "Masters List Write"
        ) && (
            <Chip
              className="btn-black-outlined mb-3"
              label="New"
              color="warning"
              onClick={() => setOpenDialog(true)}
              icon={<AddIcon />}
              variant="outlined"
            />
          )}
      </div>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: 3,
          boxShadow: 3,
          padding: 2,
        }}
      >
        <ReusableDataTable
          data={data}
          columns={columns}
          onFetchData={onFetchData}
          emptyMessage="No data found."
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          selectionMode="multiple"
          rowsPerPageOptions={[5, 10, 25, 50]}
          pagination={pagination}
          setPagination={setPagination}
          filters={filterData}
          setFilters={setFilterData}
          onRowDoubleClick={(rowData) => {
            console.log('Double-click row:', rowData);
            handleEditFamilyAsset(rowData.regionId);
          }}
        />
      </Box>
      <ReusablePrimeReactDialog
        header="Add Region"
        visible={openDialog}
        onHide={handleClear}
        //allowedRoles={["Admin", "Master List Write"]}
        style={{ overflow: 'visible' }}
        contentStyle={{ overflow: 'visible' }}
      >
        <form
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // 🔒 prevent form submission
            }
          }}
        >
          <h6>Region Name</h6>
          <TextField
            label=""
            fullWidth
            variant="outlined"
            value={assetRegionData.regionName}
            name="regionName"
            onChange={handleChange}
            sx={{ mt: 0 }}
            required
          />

          <Box sx={{ mt: 2, mb: 1, fontWeight: "bold", position: "relative" }}>
            <Typography variant="body1" sx={{ mt: 2, mb: 0, fontWeight: "bold" }}>
              Select Project
            </Typography>
            <MultiSelect
              value={assetRegionData.projectIds}
              options={projectOptions}
              optionLabel="name"
              optionValue="id"
              placeholder="Select Project"
              appendTo="self"
              style={{ width: "100%" }}
              filter
              onChange={(e: MultiSelectChangeEvent) =>
                setAssetRegionData((prev) => ({
                  ...prev,
                  projectIds: e.value as number[],
                }))
              }
            />
          </Box>

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: "30px"
          }}>
            <ReusablePrimeButton
              onClick={handleClear}
              severity="contrast"
              title="Cancel"
              type="button"

            >
              Cancel
            </ReusablePrimeButton>
            <ReusablePrimeButton className="ms-1" severity="info" onClick={handleSubmit} allowedRoles={["Admin", "Masters List Write"]}>
              Submit
            </ReusablePrimeButton>
          </div>
        </form>
      </ReusablePrimeReactDialog>
    </>
  );
};

export default Region;


